import api from '../api/config';
import { gpWhatsNewSeenBody, type ReleaseMap } from '../components/whatsNew/seenRelease';

export async function fetchBetaFeatures(): Promise<string[]> {
    try {
        const response = await api.get('/user/beta-features');
        return response.data?.betaFeatures ?? [];
    } catch (err) {
        console.error('Failed to fetch beta features:', err);
        return [];
    }
}

interface WhatsNewSeenResponse {
    success: boolean;
    lastSeenReleases?: ReleaseMap;
}

export async function markWhatsNewSeen(version: string): Promise<ReleaseMap | undefined> {
    const response = await api.post<WhatsNewSeenResponse>(
        '/user/whats-new-seen',
        gpWhatsNewSeenBody(version)
    );
    const releases = response.data?.lastSeenReleases;
    return releases && typeof releases === 'object' ? releases : undefined;
}

export async function updateUserName(fullname: string): Promise<{ name: string }> {
    const response = await api.post<{ name: string; message: string }>('/user/name', { fullname });
    return { name: response.data.name };
}
